<template>
  <div class="EnrollmentManage EnrollmentManage-importAdmissionList">
    <PageNav>
      <div class="bt_EBEEF5 admissionCue-importAdmissionList">
        <div class="head-tab--nav">
          <div class="head-nav h-3 clearFloat">
            <span class="c-normal">{{$t("Admissioncue.cp")}}</span>
            <div class="pull-right">
              <el-button type="warning" v-if="activeStep==2" size="mini" @click="onPrev()">{{$t("Admissioncue.db")}}</el-button>
              <el-button type="primary" v-if="activeStep==2" size="mini" @click="onNext()">{{$t("Admissioncue.dc")}}</el-button>
              <el-button type="warning" v-if="activeStep==3" size="mini" @click="onUpload()">{{$t("Admissioncue.dd")}}</el-button>
              <el-button type="primary" v-if="activeStep==3" size="mini" @click="onComplete()">{{$t("Admissioncue.de")}}</el-button>
            </div>
          </div>
        </div>
        <div class="content-box bg-white flex1">
          <div class="head-title">
            <el-steps
              :space="200"
              :active="activeStep"
              class="steps-pop"
              finish-status="success"
              align-center
            >
              <el-step :title="$t('Admissioncue.df')"></el-step>
              <el-step :title="$t('Admissioncue.dg')"></el-step>
              <el-step :title="$t('Admissioncue.dh')"></el-step>
            </el-steps>
            <!-- <el-form
              v-if="activeStep==2 &&upload_type!='1'"
              label-width="100px"
              :model="FormData"
              ref="FormData"
            >
              <el-form-item
                label="来源招生有效名单"
                prop="source_active"
                :rules="[{ required: true, message: '请选择来源招生有效名单' }]"
              >
                <el-select
                  v-model="FormData.source_active"
                  clearable
                  filterable
                  placeholder="选择来源招生有效名单"
                >
                  <el-option
                    v-for="item in activeList"
                    :key="item.activity_id"
                    :label="item.activity_name"
                    :value="item.activity_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>-->
          </div>
          <div class="success-tip tc fs14" v-if="activeStep==3">
            <i class="icon-success mh-success"></i>
            <p class="mt12">
              {{$t("Admissioncue.di")}}
              <span class="success">{{tipNum.success}}</span>条
            </p>
            <p>
              {{$t("Admissioncue.dj")}}
              <span class="fail">{{tipNum.fail}}</span>条
            </p>
          </div>
          <div
            class="tableDiv"
            v-if="activeStep==2"
            ref="auto_height_table"
            style="background:rgba(255,255,255,1);"
          >
            <normalTableCont
              :tableData="tableList"
              @handleColumnChange="handleColumnChange"
              @handSetting="handSetting"
            ></normalTableCont>
            <!-- 分页 -->
            <!-- <el-pagination
              style="margin: 10px;"
              :current-page.sync="paging.curPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size.sync="paging.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paging.pageTotal"
              @current-change="curPageChange"
              @size-change="pageSizeChange"
            ></el-pagination>-->
          </div>
          <!-- 失败数据列表 -->
          <div class="error-table-div" v-if="activeStep==3">
            <div class="flex-all pAll12">
              <div class="fs14">{{$t("Admissioncue.dl")}}</div>
              <!-- <el-button
                v-if="this.errorTableList.list.length>0"
                type="primary"
                size="mini"
                @click="downloadData()"
              >下载失败数据</el-button>-->
            </div>
            <div class="error-table" ref="auto_error_height_table">
              <normalTableCont :tableData="errorTableList"></normalTableCont>
            </div>
          </div>
        </div>
      </div>
    </PageNav>
  </div>
</template>
<script>
import normalTableCont from "@/components/tables/normalTableCont.vue";
import PageNav from "@/components/Nav/nav";
import storeAdmissionCue from "./admissionCue.js";
export default {
  name: "activityManageBox-importAdmissionList",
  data() {

    return {
      activeStep: 2, //步骤
      // 表单
      FormData: {
        source_active: ""
      },
      //数据条数
      tipNum: {
        success: "0",
        fail: "0",
        time: "" //下载失败数据参数
      },
      // 来源招生有效名单****下拉数据
      activeList: [],
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: null
        }
      },
      // 失败表格数据列表
      errorTableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: null
        }
      },
      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pagenovisited: 800
      }
    };
  },
  components: {
    normalTableCont,
    PageNav
  },
  updated() {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.file = decodeURI(this.$route.query.file);
    (() => {})(this.file);
    this.ImportTrack(0);
    // this.getActivityApi();
  },
  computed: {},
  methods: {
    //活动名单管理->导入招生有效名单
    ImportTrack(step) {
      storeAdmissionCue
        .ImportTrack({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id:this.school_id,
          url: this.file,
          step: step //0-模拟数据 1-导入并获取错误列表
        })
        .then(res => {
          if (step == 0) {
            this.tableList.columns = res.data.data.field;
            if (res.data.code === 200) {
              this.tableList.list = res.data.data.list;
            } else {
              this.tableList.list = [];
              this.tableList.options.errortip = res.data.msg;
            }
          } else {
            // 提交****导入文件
            this.errorTableList.columns = res.data.data.field;
            this.tipNum = {
              success: res.data.data.suc,
              fail: res.data.data.fal,
              time: res.data.data.time
            };
            if (res.data.code === 200) {
              this.activeStep = 3;
              this.errorTableList.list = res.data.data.falarray;
              this.$nextTick(() => {
                if (this.$refs["auto_error_height_table"]) {
                  this.errorTableList.options.tableHeight = this.$Common.getTableHeight(
                    this.$refs.auto_error_height_table.getBoundingClientRect()
                      .top + 62
                  );
                }
              });
            } else {
              this.errorTableList.list = [];
              this.errorTableList.options.errortip = res.data.msg;
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          }
        });
    },
    // 招生管理->招生有效名单列表*****来源招生有效名单
    getActivityApi() {
      storeAdmissionCue
        .getActivityApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          upload_type: this.upload_type
        })
        .then(res => {
          if (res.data.code === 200) {
            this.activeList = res.data.data.list;
          } else {
            this.activeList = [];
          }
        });
    },
    // 点击上一步
    onPrev() {
      this.$router.push({ path: "/AdmissionCue/importAdmission" });
    },
    // 点击下一步
    onNext() {
      this.ImportTrack(1);
      // if (this.upload_type != "1") {
      //   this.$refs["FormData"].validate(valid => {
      //     if (valid) {
      //       this.NextStepActivity();
      //     } else {
      //       return false;
      //     }
      //   });
      // } else {
      //   this.NextStepActivity();
      // }
    },
    // 下载失败数据
    downloadData() {
      let url = storeAdmissionCue.importFal();
      let data = this.tipNum.time;
      let _this = this;
      window.open(
        this.$buildExportUrl(`${url}?marketer_id=${this.marketer_id}&token=${this.token}&company_id=${this.company_id}&upload_type=${this.upload_type}&time=${data}`),
        "_blank"
      );
    },
    // 点击继续上传
    onUpload() {
      this.$router.push({ path: "/Admissioncue/importAdmission" });
    },
    // 点击完成
    onComplete() {
      this.$router.push({ path: "/ListAllocationManagement/preSetValidList" });
    },
    // 表格内容绑定事件**********查看
    handleColumnChange(k, v, column) {
      (() => {})(k, v, column);
      this.userSeeingInfo.isFllow = false; //是否为直接到跟进部分
      this.userSeeingInfo.showVisable = !this.userSeeingInfo.showVisable; //查看招生名单
    },
    // 编辑列编辑提交
    handSetting(v) {
      (() => {})(v);
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
    },
    // pageSize改变
    pageSizeChange() {
      this.paging.curPage = 1;
    },
    handleClose(done) {
      done();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 42
        );
      }
    });
  }
};
</script>

<style lang="less">
@import url("../../assets/less/enrollmentManage.less");
.EnrollmentManage-importAdmissionList {
  height: 100vh;
  font-size: 20px;
  .admissionCue-importAdmissionList {
    .flex-line {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
    }
    .content-box {
      margin: 20px 20px 0px 20px;
      padding: 20px;
      border: 1px solid #ddd;
    }
    .head-title {
      position: relative;
      padding: 20px 12px;
      .el-form {
        position: absolute;
        top: 20px;
        right: 12px;
      }
    }
    .success-tip {
      line-height: 20px;
      margin-top: 20px;
      margin-bottom: 60px;
      i {
        font-size: 40px;
        color: #249b23;
      }
      .success {
        color: #249b23;
      }
      .fail {
        color: #ff1010;
      }
    }
    .error-table {
      .el-table__body tr td:nth-last-of-type(1) {
        color: #ff1010;
      }
    }
  }
}
</style>
